import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { useTranslation } from "react-i18next";
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import { motion } from "framer-motion";
import "./index.scss";

import Pagination from "../../../../../components/ui/Pagination";
import NoDataFound from "../../../../../components/ui/NoDataFound";
import Button from "../../../../../components/ui/Button";
import RadioButton from "../../../../../components/ui/RadioButton";
import { toaster } from "../../../../../components/ui/Toaster";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { filterIcon, searchIcon, viewMoreIcon } from "../../../../../utils/icons";

import { useSelector, useDispatch } from 'react-redux';
import { getMobileAppsList, validateList, resetValidateResponse, deleteMobileAppList, resetDeleteMobileAppResponse, resetMobileAppsList } from "../../../../../store/actions/scanInfoAction";
import { getloggedInUserType } from "../../../../../utils/util";


const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const platformOption = [
    {
        label: "IOS",
        value: "ios"
    },
    {
        label : "Android",
        value: "android"
    },
    {
        label: "All",
        value: "all"
    }
]

const MobileApps = () => {

    const mobileAppsListResponse = useSelector((state) => state.scanInfo?.mobileAppsList);
    const validateResponse = useSelector((state) => state?.scanInfo?.validateResponse);
    const deletMobileAppResponse = useSelector((state) => state?.scanInfo?.deletMobileAppResponse)

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerListFetch,
        setTriggerListFetch,
    } = useScanInfoContext();

    const viewMoreWrapperRef = useRef(null);
    const filterWrapperRef = useRef(null);

    const [searchValue, setSearchValue] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);
    
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [scanNotFound, setScanNotFound] = useState(false);
    const [showViewMore, setShowViewMore] = useState(false);
    const [mobileAppsLists, setMobileAppsLists] = useState(null);
    // modal state
    const [selectedValid, setSelectedValid] = useState("");
    const [showActionModal, setShowActionModal] = useState(false);
    const [modalType, setModalType] = useState("")
    const [selectedData, setSelectedData] = useState("");
    const [modalLoading, setModalLoading] = useState(false);

    //filter value
    const [showFilter, setShowFilter] = useState(false);
    const [newFindingsType, setNewFindingsType] = useState("");
    const [selectedPlatform, setSelectedPlatform] = useState("");

    //selected filter value
    const [selectedFilterValue, setSelectedFilterValue] = useState({});


    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const applyFilter = () => {
        setCurrentPage(1);
        let obj = {
            findings: newFindingsType,
            platform: selectedPlatform,
        }
        setSelectedFilterValue(obj)
        setShowFilter(false);
    }

    const isAnyFilterActive = Object.values(selectedFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {        
        setCurrentPage(1);
        setSelectedFilterValue({})
        setNewFindingsType("");
        setSelectedPlatform("");
    }

    const onSearch = () => {
        setCurrentPage(1)
        setSearchQuery(searchValue)
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const fetchRecordData = useCallback(()=>{
        setIsLoading(true)
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const queryParams = searchQuery ? `&query=${searchQuery}`: "";
        const newFindings = selectedFilterValue.findings && selectedFilterValue.findings !== "all" ? `&new_record=${selectedFilterValue.findings === "yes" ? true : false}` : "";
        const platform = selectedFilterValue.platform && selectedFilterValue.platform !== "all" ? `&platform=${selectedFilterValue.platform}` : "";
        const url = `${baseUrl}${params}${queryParams}${newFindings}${platform}`
        dispatch(getMobileAppsList(url))
    },[dispatch, currentPage, currentPageSize, domainId, scanId, organizationId, searchQuery, selectedFilterValue])

    const saveUpdate = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            result_id: selectedData?.id,
            false_positive: selectedValid === "valid" ? false : true
        }
        dispatch(validateList(obj))
    }

    const confirmDelete = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            result_id: selectedData?.id
        }
        dispatch(deleteMobileAppList(obj))
    }

    useEffect(() => {
        fetchRecordData();       
    }, [searchQuery, currentPage, fetchRecordData]);

    useEffect(() => {
        if (triggerListFetch) {
            setCurrentPage(1);
            setTriggerListFetch(false);
        }
    }, [triggerListFetch, currentPage, setTriggerListFetch]);

    useEffect(()=>{
        if(mobileAppsListResponse !== null) {
            setMobileAppsLists(mobileAppsListResponse)
            if(mobileAppsListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            dispatch(resetMobileAppsList())
            setIsLoading(false)
        }
    },[mobileAppsListResponse, dispatch])

    useEffect(()=>{
        if(validateResponse !== null) {
            setShowActionModal(false);
            setModalLoading(false)
            if(validateResponse?.status === "success") {
                toaster.addToast(validateResponse?.description,"success")
                fetchRecordData()
            } else {
                toaster.addToast(validateResponse?.description,"error")
            }
            dispatch(resetValidateResponse())
        }
    },[validateResponse, fetchRecordData, dispatch])

    useEffect(() => {
        if(deletMobileAppResponse !== null) {
            setShowActionModal(false);
            setModalLoading(false)
            if(deletMobileAppResponse?.status === "success") {
                toaster.addToast(deletMobileAppResponse?.description,"success")
                fetchRecordData()
            } else {
                toaster.addToast(deletMobileAppResponse?.description,"error")
            }
            dispatch(resetDeleteMobileAppResponse())
        }
    },[deletMobileAppResponse, fetchRecordData, dispatch])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (viewMoreWrapperRef.current && !viewMoreWrapperRef.current.contains(event.target)) {
                if(showViewMore){
                    setShowViewMore(false)
                }
            }
        
        }
    },[showViewMore])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }
        
        }
    },[showFilter])

    return (
        <>
            <div className="git-leaks-main-content bg-white-with-shadow p-3">
                <div className="search-header-container d-flex align-items-center gap-3">
                    <div className="d-flex gap-3" onKeyDown={handleSearchKeyDown}>
                        <div className="search-container position-relative">
                            <span className="position-absolute">{searchIcon()}</span>
                            <input type="text" 
                                placeholder="Search" 
                                value={searchValue} 
                                onChange={(e)=>{
                                    setSearchValue(e.target.value)
                                }}
                                onFocus={() => setIsSearchFocused(true)}
                                onBlur={() => setIsSearchFocused(false)}
                            />
                        </div>
                        <button className="search-btn" onClick={onSearch}>Search</button>
                    </div>
                    <div className="position-relative">
                        <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>                        
                        {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                        {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                            <h6>New Findings</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    newFindingsOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={index} isChecked={data.value === newFindingsType} />
                                        )
                                    })
                                }
                            </div>
                            <h6>Platform</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    platformOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={`platform-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedPlatform(value)}} key={index} isChecked={data.value === selectedPlatform} />
                                        )
                                    })
                                }
                            </div>
                            <div className="filter-apply-btn mt-3">
                                <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={newFindingsType === ""} buttonClicked={()=>{applyFilter()}}/>
                            </div>
                        </div>}
                    </div>
                </div>
                <div className="table-container mt-3">                    
                    {
                        isLoading ?
                        <SkeletonLoader type={"line"} count={5} currentPage={"mobileApps"} />
                        :
                        <Table>
                            <thead>
                                <tr>
                                    <th>Platform</th>
                                    <th>Name</th>
                                    <th>App ID</th>
                                    <th>Developer</th>
                                    <th>URL</th>
                                    <th>Summary</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    mobileAppsLists?.results?.length > 0 &&
                                    mobileAppsLists?.results.map((data, index) => {
                                        return (
                                            <motion.tr
                                                key={index}
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                            >
                                                <td>
                                                    <p>{data?.platform}</p>
                                                    {data?.new_record && <p className="d-inline-block new-data my-2">New</p>}
                                                </td>
                                                <td>
                                                    {data?.app_name}
                                                    {data?.false_positive && <p className="d-inline-block false-positive">False Positive</p>}
                                                </td>
                                                <td className="table-app-id">
                                                    <p>{data?.app_id}</p>
                                                </td>
                                                <td>
                                                    {data?.app_developer}
                                                </td>
                                                <td>
                                                    <a className="table-url" href={data?.app_url} target="_blank" rel="noreferrer">{data?.app_url}</a>
                                                </td>
                                                <td>
                                                    {data?.app_summary}
                                                </td>
                                                <td>
                                                    <div className="view-more-div position-relative">
                                                        <span onClick={()=>{
                                                            setShowViewMore(true)
                                                            setSelectedData(data)
                                                        }}>{viewMoreIcon()}</span>
                                                        {showViewMore && data.id === selectedData.id && <div className="more-option-container position-absolute" ref={viewMoreWrapperRef}>                                                            
                                                            {getloggedInUserType() === "internal" && <p onClick={()=>{
                                                                setModalType("valid")
                                                                setSelectedValid(data?.false_positive ? "falsePositive" : "valid")                                                              
                                                                setShowActionModal(true)
                                                            }}>Validate</p>}
                                                            <p onClick={()=>{
                                                                setModalType("delete")                                                                                                                                
                                                                setShowActionModal(true)
                                                            }}>Delete</p>                                                            
                                                        </div>}
                                                    </div>
                                                </td>
                                            </motion.tr>
                                        )
                                    })
                                }
                                {
                                    !isLoading && mobileAppsLists !== "" && mobileAppsLists?.results?.length === 0 &&
                                    <motion.tr
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <td colSpan={6}>
                                            <NoDataFound noDataText={"No Record Found"}/>
                                        </td>
                                    </motion.tr>
                                    
                                }
                                { scanNotFound &&
                                    <motion.tr
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <td colSpan={6}>
                                            <NoDataFound noDataText={mobileAppsLists?.description} />
                                        </td>                                        
                                    </motion.tr>
                                }
                            </tbody>
                        </Table> 
                    }                                                           
                </div>                
                {mobileAppsLists !== "" && mobileAppsLists?.results?.length > 0 && <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    pageSize={currentPageSize}
                    totalCount={mobileAppsLists?.meta?.total_results}
                    onPageChange={setCurrentPageandRecordSize}
                />}
            </div>
            <Modal
                show={showActionModal}
                onHide={() => setShowActionModal(false)}
                size="md"
                centered
                >
                    {modalType === "delete" && <Modal.Body>
                        <div className="delete-organization-container">
                            <h4>Delete</h4>
                            <div className="organization-related-details p-4 m-2">
                                <p>Are you sure, want to delete?</p>
                                
                            </div>
                            <div className="delete-organization-btn d-flex gap-3 m-2">
                                <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                {!modalLoading && <Button buttonText="Delete" buttonType={"primary"} buttonClicked={() => confirmDelete()} />}
                                {modalLoading && <Button buttonText="Loading..." disableButton={true} buttonType={"secondary"} />}
                            </div>
                        </div>
                    </Modal.Body>}
                    {modalType === "valid" && <Modal.Body>
                        <div className="delete-organization-container">
                            <h4>Validate</h4>
                            <div className="organization-related-details p-4 m-2">
                                <p className="mb-4">Please Select below option</p>
                                <div className="filter-user-status d-flex mb-4 gap-4">
                                    <RadioButton radioId={1} radioValue={"valid"} radioLabel={"Valid"} onChange={(data)=>{setSelectedValid(data)}} isChecked={selectedValid === "valid"} />
                                    <RadioButton radioId={2} radioValue={"falsePositive"} radioLabel={"False Positive"} onChange={(data)=>{setSelectedValid(data)}} isChecked={selectedValid === "falsePositive"} />
                                </div>                                
                            </div>
                            <div className="d-flex gap-3 m-2">
                                <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                {!modalLoading && <Button buttonText="Save" buttonType={"primary"} disableButton={selectedValid === ""} buttonClicked={() => saveUpdate()} />}
                                {modalLoading && <Button buttonText="Loading..." buttonType={"primary"} disableButton={true} />}
                            </div>
                        </div>
                    </Modal.Body>}
            </Modal>           
        </>        
    )
}


export default MobileApps;